import { render, staticRenderFns } from "./DailySentence_child.vue?vue&type=template&id=0dc8ed12&"
import script from "./DailySentence_child.vue?vue&type=script&lang=js&"
export * from "./DailySentence_child.vue?vue&type=script&lang=js&"
import style0 from "./DailySentence_child.vue?vue&type=style&index=0&id=0dc8ed12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports